'use client';

import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["colorSet", "popoverTitle", "popoverTitleId", "children", "onClose", "className", "closeButtonAriaLabel", "closeButtonRef"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { ENCORE_DATA_IDS } from "../../dataEncoreIds.mjs";
import { addColorSet, deprecatedOverlayDirections } from "../../styles/index.mjs";
import { IconX } from "../Icon/icons/IconX/index.mjs";
import { CloseButton } from "./CloseButton.mjs";
import { Popover as PopoverElement } from "./Popover.mjs";
import { Title } from "./Title.mjs";
var PopoverComponent = /*#__PURE__*/React.forwardRef(function PopoverComponent(_ref, ref) {
  var _ref$colorSet = _ref.colorSet,
    colorSet = _ref$colorSet === void 0 ? 'base' : _ref$colorSet,
    popoverTitle = _ref.popoverTitle,
    popoverTitleId = _ref.popoverTitleId,
    children = _ref.children,
    onClose = _ref.onClose,
    className = _ref.className,
    _ref$closeButtonAriaL = _ref.closeButtonAriaLabel,
    closeButtonAriaLabel = _ref$closeButtonAriaL === void 0 ? 'Close' : _ref$closeButtonAriaL,
    closeButtonRef = _ref.closeButtonRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(PopoverElement, Object.assign({
    ref: ref,
    role: "dialog",
    "aria-labelledby": popoverTitleId,
    paddedBody: !!(onClose && !popoverTitle),
    className: addColorSet(colorSet, className),
    colorSet: colorSet
  }, props, {
    "data-encore-id": ENCORE_DATA_IDS.Popover
  }), popoverTitle && /*#__PURE__*/React.createElement(Title, {
    id: popoverTitleId
  }, popoverTitle), children, onClose && /*#__PURE__*/React.createElement(CloseButton, {
    ref: closeButtonRef,
    onClick: onClose,
    "aria-label": closeButtonAriaLabel,
    type: "button",
    iconOnly: IconX
  }));
});
var popoverHelpers = _objectSpread({}, deprecatedOverlayDirections);
export var Popover = Object.assign(PopoverComponent, popoverHelpers);